import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { ref } from 'vue';
import { PaginatedParams } from 'ah-api-gateways';
import OptionPremiumSchedulePaymentsListing from 'ah-trades/src/components/lists/OptionPremiumSchedulePaymentsListing.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionPaymentScheduleModal',
  props: {
  tradeId: {
    type: String,
    required: true,
  },
  buttonLabel: {
    type: String,
    default: 'View Premium Settlement Schedule',
  },
  modalTitle: {
    type: String,
    default: 'Premium Settlement Schedule',
  },
},
  setup(__props) {



const modalShown = ref(false);

function show() {
  modalShown.value = true;
}

function hide() {
  modalShown.value = false;
}

const defaultSortAndPageParams = {
  sort: 'date',
  sortDirection: 'ASC',
  pageSize: 50,
} as Partial<PaginatedParams>;

return { __sfc: true,modalShown, show, hide, defaultSortAndPageParams, BModal, OptionPremiumSchedulePaymentsListing }
}

})